import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Shield, Lock, Eye, Key } from 'lucide-react';
import Footer from '../components/Footer';

export default function Privacy() {
  return (
    <>
      <Helmet>
        <title>Política de Privacidad - Concurso de Árboles de Navidad</title>
        <meta 
          name="description" 
          content="Política de privacidad del concurso de árboles de Navidad. Información sobre el tratamiento de datos personales." 
        />
      </Helmet>

      <div className="min-h-screen pt-16">
        <div className="bg-primary text-white py-20">
          <div className="container mx-auto px-4 text-center">
            <Shield className="h-16 w-16 mx-auto mb-6 text-secondary" />
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Política de Privacidad</h1>
            <p className="text-xl text-gray-200 max-w-2xl mx-auto">
              Información sobre el tratamiento de tus datos personales
            </p>
          </div>
        </div>

        <div className="container mx-auto px-4 py-12">
          <div className="max-w-3xl mx-auto space-y-12">
            <section>
              <div className="flex items-center mb-4">
                <Lock className="h-6 w-6 text-primary mr-2" />
                <h2 className="text-2xl font-bold text-gray-900">Responsable del Tratamiento</h2>
              </div>
              <div className="prose prose-lg">
                <p>
                  <strong>Iznoval Digital Solutions S.L.</strong><br />
                  CIF: B40648214<br />
                  Domicilio: Avenida Camp de Morvedre 99, Puerto de Sagunto, Valencia<br />
                  Email: hola@iznoval.com
                </p>
              </div>
            </section>

            <section>
              <div className="flex items-center mb-4">
                <Eye className="h-6 w-6 text-primary mr-2" />
                <h2 className="text-2xl font-bold text-gray-900">Finalidad del Tratamiento</h2>
              </div>
              <div className="prose prose-lg">
                <p>Los datos personales que nos proporciones serán tratados con las siguientes finalidades:</p>
                <ul>
                  <li>Gestionar tu participación en el concurso de árboles de Navidad</li>
                  <li>Comunicarte el estado de tu participación y posibles premios</li>
                  <li>Mostrar públicamente tu nombre y foto del árbol en la web del concurso</li>
                  <li>Enviarte comunicaciones relacionadas con el concurso</li>
                </ul>
              </div>
            </section>

            <section>
              <div className="flex items-center mb-4">
                <Key className="h-6 w-6 text-primary mr-2" />
                <h2 className="text-2xl font-bold text-gray-900">Base Legal</h2>
              </div>
              <div className="prose prose-lg">
                <p>El tratamiento de tus datos está basado en:</p>
                <ul>
                  <li>Tu consentimiento expreso al participar en el concurso</li>
                  <li>La necesidad de ejecutar la relación contractual del concurso</li>
                  <li>Nuestro interés legítimo en gestionar y promocionar el concurso</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Derechos</h2>
              <div className="prose prose-lg">
                <p>Puedes ejercer tus derechos de:</p>
                <ul>
                  <li>Acceso a tus datos personales</li>
                  <li>Rectificación de datos inexactos</li>
                  <li>Supresión de datos</li>
                  <li>Limitación del tratamiento</li>
                  <li>Portabilidad de datos</li>
                  <li>Oposición al tratamiento</li>
                </ul>
                <p>
                  Para ejercer estos derechos, puedes contactarnos en hola@iznoval.com
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Conservación</h2>
              <div className="prose prose-lg">
                <p>
                  Conservaremos tus datos durante el tiempo necesario para cumplir con las finalidades 
                  descritas y para cumplir con nuestras obligaciones legales. En particular:
                </p>
                <ul>
                  <li>Datos de participación: durante la duración del concurso y 1 año después</li>
                  <li>Datos de ganadores: 4 años por obligaciones fiscales</li>
                  <li>Datos de contacto: hasta que solicites su supresión</li>
                </ul>
              </div>
            </section>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}